import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const UsageLimitComponent = (props) => {
  console.log("usage limit",props.useageLimit)
  return (
    <div className="bp-form-row">
      <div className="bp-form-column">
        <FormControl fullWidth className="bp-form-field">
          <InputLabel>Select type id</InputLabel>
          <Select
            name="limit_type_id"
            onChange={(e) => props.handleSelectChange(e.target.value)}
            value={props.userLimit.limit_type_id || ''}
          >
            <MenuItem value="">
              <em>Select type id</em>
            </MenuItem>
            {props.useageLimit &&
              props.useageLimit.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.type}_{item.sub_type}, {item.duration} {item.duration_unit.trim()}(s)
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <TextField
          className="bp-form-field"
          fullWidth
          label="Value"
          name="value"
          value={props.userLimit.value}
          onChange={(e) => props.handleChangeUserLimit(e)}
        />
      </div>
    </div>
  );
};

export default UsageLimitComponent;